import { useState, useEffect } from 'react';
import axios from 'axios';
import Router from './routes';
import ThemeConfig from './theme';
import GlobalStyles from './theme/globalStyles';
import { BaseOptionChartStyle } from './components/charts/BaseOptionChart';
import './App.css';
import { CityService } from './application/CityService';
import useCityStore from './infrastructure/store/useCityStore'; // 匯入 store

export default function App() {
  const setCitySettings = useCityStore(state => state.setCitySettings); // 從 store 中取得 setCitySettings 函數
  const setPathnamelist = useCityStore(state => state.setPathnamelist); // 從 store 中取得 setPathnamelist 函數
  const pathnamelist = useCityStore(state => state.pathnamelist); // 從 store 中取得 pathnamelist
  const [dataInitialized, setDataInitialized] = useState(false); // 狀態來追蹤 initializeData 是否完成

  useEffect(() => {
    console.log('App.js useEffect');
    async function initializeData() {
      const cityService = new CityService();
      try {
        const citySettings = await cityService.getCitySettings();
        setCitySettings(citySettings); // 將 citySettings 存入 store
        const paths = await cityService.getCityPaths(); // 獲取城市路徑
        setPathnamelist(paths); // 將 pathnamelist 存入 store

        setDataInitialized(true); // 設置 dataInitialized 為 true
      } catch (error) {
        console.error('Failed to initialize data:', error);
      }
    }

    initializeData();
  }, [setCitySettings, setPathnamelist]);
  useEffect(() => {
    if (dataInitialized) {
      const currentPath = window.location.pathname.replace(/\s+/g, '');
      const isException = pathnamelist.some((item) => `/${item.path}`.replace(/\s+/g, '') === currentPath);

      if (!isException) {
        if (localStorage.email !== undefined) {
          console.log();
        } else if (currentPath !== '/login') {
          window.location.href = '/login';
        }
      }
    }
  }, [dataInitialized, pathnamelist]);

  return (
    <ThemeConfig>
      <GlobalStyles />
      <BaseOptionChartStyle />
      <Router />
    </ThemeConfig>
  );
}